import CommunicationBoard from '@/containers/SubscriptionFormPageNew/Components/CommunicationBoard/CommunicationBoard'
import CreditBooster from '@/containers/SubscriptionFormPageNew/Components/CreditBooster/CreditBooster'
import Distributor from '@/containers/SubscriptionFormPageNew/Components/Distributor/Distributor'
import FidelityMaximizerSidebar from '@/containers/SubscriptionFormPageNew/Components/FidelityMaximizer/FidelityMaximizerSidebar'
import HistoricSales from '@/containers/SubscriptionFormPageNew/Components/HistoricSales/HistoricSales'
import IbanVerifier from '@/containers/SubscriptionFormPageNew/Components/IbanVerifier/IbanVerifier'
import Resources from '@/containers/SubscriptionFormPageNew/Components/Resources/Resources'
import SalesScript from '@/containers/SubscriptionFormPageNew/Components/SalesScript/SalesScript'
import ScheduleCallback from '@/containers/SubscriptionFormPageNew/Components/ScheduleCallback/ScheduleCallback'
import Tools from '@/containers/SubscriptionFormPageNew/Components/Tools/Tools'
import RightPanelToggle from './RightPanelToggle'
import ScheduleCallbackRailEntry from './ScheduleCallbackRailEntry/ScheduleCallbackRailEntry'
import useRightPanelLayout, { sidebarBlockId } from './useRightPanelLayout'
import { CallbackSlot, RightPanelColumn, RightPanelToggleRow, SidebarBlock } from './styled-components'

interface RightPanelProps {
  country: string
}

const RightPanel = ({ country }: RightPanelProps) => {
  const { hidden, expanded, rail, ibanVerifierHidden } = useRightPanelLayout(country)

  if (hidden) return null

  return (
    <RightPanelColumn $expanded={expanded} data-rail-card={rail || undefined}>
      <RightPanelToggleRow $expanded={expanded}>
        <RightPanelToggle />
      </RightPanelToggleRow>
      <SidebarBlock id={sidebarBlockId('communication-board')} $rail={rail}>
        <CommunicationBoard />
      </SidebarBlock>
      <SidebarBlock id={sidebarBlockId('schedule-callback')} $plain $rail={rail}>
        <CallbackSlot hidden={rail}>
          <ScheduleCallback />
        </CallbackSlot>
        <CallbackSlot hidden={!rail}>
          <ScheduleCallbackRailEntry />
        </CallbackSlot>
      </SidebarBlock>
      <SidebarBlock id={sidebarBlockId('sales-script')} $rail={rail}>
        <SalesScript />
      </SidebarBlock>
      <SidebarBlock id={sidebarBlockId('credit-booster')} $rail={rail}>
        <CreditBooster country={country} />
      </SidebarBlock>
      <SidebarBlock id={sidebarBlockId('fidelity-maximizer')} $rail={rail}>
        <FidelityMaximizerSidebar />
      </SidebarBlock>
      <SidebarBlock id={sidebarBlockId('iban-verifier')} $rail={rail}>
        <IbanVerifier hidden={ibanVerifierHidden} />
      </SidebarBlock>
      <SidebarBlock id={sidebarBlockId('distributor')} $rail={rail}>
        <Distributor />
      </SidebarBlock>
      <SidebarBlock id={sidebarBlockId('resources')} $rail={rail}>
        <Resources country={country} />
      </SidebarBlock>
      <SidebarBlock id={sidebarBlockId('historic-sales')} $rail={rail}>
        <HistoricSales />
      </SidebarBlock>
      <SidebarBlock id={sidebarBlockId('tools')} $rail={rail}>
        <Tools />
      </SidebarBlock>
    </RightPanelColumn>
  )
}

export default RightPanel
